export enum Gender {
  "male" = "Male",
  "female" = "Female",
  "non-binary" = "Non Binary",
  "prefer-not-to-say" = "Prefer not to say",
  "other" = "Other",
  "-" = "-",
}

export enum UserRolesEnum {
  "admin" = "ADMIN",
  "default" = "DEFAULT",
}

export enum Status {
  "unassigned" = "Unassigned",
  "trial" = "Trial",
  "lifetime" = "Lifetime",
  "grace" = "Grace",
  "active" = "Active",
  "suspended" = "Suspended",
}

const formatLabel = (enumKey: string) =>
  enumKey
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const GENDER_ITEMS = Object.entries(Gender).map(([value, key]) => ({
  label: formatLabel(key),
  key: value,
}));

export const ROLE_ITEMS = Object.entries(UserRolesEnum).map(([key, value]) => ({
  label: formatLabel(key),
  key: value,
}));

export const STATUS_ITEMS = Object.entries(Status).map(([key, value]) => ({
  key: key,
  label: value,
}));
